import styled from 'styled-components'

interface LogoContainerProps {
  isSigned: boolean
  color?: string
}

export const LogoContainer = styled.div<LogoContainerProps>`
  width: ${props => (props.isSigned ? '20%' : '9%')};

  img {
    width: 100%;
    max-width: 180px;
    height: auto;
    ${props =>
      props.color === '#F8F9FD' &&
      `filter: brightness(0) saturate(100%) invert(95%) sepia(1%) saturate(2203%) hue-rotate(185deg) brightness(105%) contrast(97%);`}
    ${props =>
      props.color === '#21105D' &&
      `filter: brightness(0) saturate(100%) invert(9%) sepia(85%) saturate(4645%) hue-rotate(245deg) brightness(88%) contrast(105%);`}
  }

  @media only screen and (max-width: 724px) {
    width: 40%;
  }
`
